'use strict';

import React, { Component } from 'react';
import ValidationOverlayJsonForm from './registerProspects.jsx';
import PopUp from '../../../commonModules/interface/PopUp';
import { Alert } from '@material-ui/lab';
import { toast } from 'react-toastify';

class ValidationOverlayJsonFormList extends Component{

    state = {
        user: this.props.user,
        // popupState: this.props.popupStateButton,
        msg: this.props.msg,
        previousButtonStatus: false,
        errormsg: "",
        schemaList: ["","","","",""],
        forms: ["",""],
        id: 0,
    }

    componentWillMount(){
        // Get Schema to be trasnform from Prospect to Client
        try {
            fetch('/schema/getInstallationForm?boxAssoId='+this.props.user, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',                    
            }).then(
                (res) => res.json()

            ).then(
                (resp)=>{
                    console.log(resp,"---------------------------_>>>>>");
                    this.setState({schemaList: resp.content.schemaList});
                }
            ).catch( (e) => console.log('error get list ',e))           
        } catch (err) {
            console.log("[ERROR], getting prospect List data",err)
        }
    }
   
    cancel = async (e) => {
        e.preventDefault();
        console.log("[INFO],regiserInstallation,Cancel Validation");
        // this.setState({popupState: "overlay hidden",errormsg:""});
        this.props.onCancelation();
    }
    previous = async (e) => {
        e.preventDefault();
        let val = this.state.id;
        console.log("[INFO],regiserInstallation,Go Back to previous Validation");
      
        if (val >= 1){
            val = val -1;
        } else {
            val = 0;
        }
        if (val === 0){
            this.setState({ previousButtonStatus: false });
        }
        this.setState({id: val});
    }

    onPreSubmit = async (form) => {
        let val = this.state.id;
        console.log('[INFO],regiserInstallation,Submit form ',val);
        console.log('[INFO],regiserInstallation,Submit form Data :',form.formData);

        if (val === 0){
            console.log('[INFO],regiserInstallation, check Initial Parameter',val);
            try {
                const response = await fetch('/installation/checkbox', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    credentials: 'same-origin',                    
                    body: JSON.stringify({
                        model: form.formData.model,
                        box_id: form.formData.boxid,
                        serial_number: form.formData.serialnumber,
                        boxAssoId: this.props.user,
                    })
                });
                const resp = await response.json();
                console.log(resp);
                if (resp.error != "OK" ){
                    this.setState({ errormsg: resp.content.toString() });                    
                    return;
                }
            } catch (err) {
                console.log('[ERROR],check installation, ',err);
                this.setState({
                    errormsg: 'Error : ' + err.error
                });
                toast.error( err.error)
                return;
            }
        }
        
        if (val >= 4){
            this.onSubmit(form);
            return;
        }
        //Hide the previous button
        if (val >= 0){
            this.setState({previousButtonStatus: true });
        }
        let new_form = this.state.forms;
        new_form[val] = form.formData;

        this.setState({
            id: val+1,
            forms: new_form,
            errormsg: ""
        });
    }
    onSubmit = async (form) => {
        let last_form = this.state.forms;
        last_form.push(form.formData);
        let forms = [];
        forms.push({'info': last_form[0],
            'schemaID': this.state.schemaList[0]});
        forms.push({'info': last_form[1],
            'schemaID': this.state.schemaList[1]});
        forms.push({'info': last_form[2],
            'schemaID': this.state.schemaList[2]});
        forms.push({'info': last_form[3],
            'schemaID': this.state.schemaList[3]});
        forms.push({'info': last_form[4],
            'schemaID': this.state.schemaList[4]});

        console.log("[INFO],regiserInstallation, Data submitted: ",last_form);
        try {
            const response = await fetch('/installation/record', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',                    
                body: JSON.stringify({
                    forms: forms,
                    boxAssoId: this.props.user,
                })
            });
            const resp = await response.json();
            console.log(resp);
            if (resp.error != "OK" ){
                this.setState({errormsg: resp.content.toString()});                    
                return;
            }

            this.props.onValidation();
        } catch (err) {
            console.log('[ERROR],regiserInstallation, ',err);
            this.setState({
                errormsg: 'Error : ' + err.error,
                id: 0 // return to first form
            });

            toast.error( err.error)
        }
    }

    render() {
        console.log("[DEBUG],regiserInstallation, ",this.state.schemaList[this.state.id]);
        return (
            <PopUp
                close={this.state.previousButtonStatus ? this.previous : this.cancel}
                title={this.props.name}
                // submitAction={this.onPreSubmit}
                // submitAction={this.state.previousButtonStatus ? this.onSubmit : this.onPreSubmit}
                // submitTitle={this.state.previousButtonStatus ? "Valider": "Suivant"}
            >
                <ValidationOverlayJsonForm
                    schemaID={this.state.schemaList[this.state.id]}
                    onValidation={this.onPreSubmit}
                    initFormData={this.state.forms[this.state.id]}
                />
                {this.state.errormsg &&
                    <Alert severity="error">{this.state.errormsg}</Alert>
                }
            </PopUp>
            // <div className={this.state.popupState}>
            //     <div className="popup">
            //         <h1>{this.props.name}</h1>
            //         <ValidationOverlayJsonForm
            //             schemaID={this.state.schemaList[this.state.id]}
            //             onValidation={this.onPreSubmit}
            //             initFormData={this.state.forms[this.state.id]}
            //         />
            //         {/* <i style={{color: "red"}}><p>{this.state.errormsg}</p></i> */}
            //         {this.state.errormsg &&
            //             <Alert severity="error">{this.state.errormsg}</Alert>
            //         }
            //         <div className="text-right">
            //             <button className={this.state.previousButtonStatus} onClick={this.previous}>Previous</button>
            //             <button className="btn btn-cancel" onClick={this.cancel}>Cancel</button>
            //         </div>
            //     </div>
            // </div>
        );
    }
};
export default ValidationOverlayJsonFormList

//module.exports = ValidationOverlayJsonFormList;
